const AboutModal = ({ onClose }) => (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>About 蜃気楼 Shinkiro (Mirage)</h2>
        <img 
          src="https://giffiles.alphacoders.com/220/220341.gif" 
          alt="Anime aesthetic" 
          className="anime-image" 
        />
        
        <p>
          蜃気楼-Shinkiro is a powerful Markdown editor. Some of its key features include:
        </p>
        
        <ul>
          <li>Real-time Markdown preview</li>
          <li>Graph view for document connections</li>
          <li>Dark mode support</li>
          <li>Markdown editing assistance</li>
          <li>Syntax highlighting</li>
          <li>File management</li>
        </ul>
        
        <div className="keyboard-shortcuts">
          <h3>Keyboard Shortcuts</h3>
          <ul>
            <li>Ctrl+B: Bold text</li>
            <li>Ctrl+I: Italic text</li>
            <li>Ctrl+K: Insert link</li>
            <li>Ctrl+S: Save note</li>
          </ul>
        </div>
        
        <div className="modal-footer">
          <p>Made by: Saboten758 <a 
            href="https://github.com/Saboten758/shinkiro-frontend" 
            target="_blank" 
            rel="noopener noreferrer"
            className="github-link"
          >
            View on GitHub
          </a></p>
        </div>
  
        <button className="btn close-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );

  export default AboutModal;